import { CommonCallAdapter, CallComposite } from '@azure/communication-react';
import { Spinner } from '@fluentui/react';
import { useSwitchableFluentTheme } from '../theming/SwitchableFluentThemeProvider';
import { useIsMobile } from '../utils/useIsMobile';
import { useEffect } from 'react';
import { CallScreenProps } from './CallScreen';

export type CallCompositeContainerProps = CallScreenProps & { adapter?: CommonCallAdapter };

export const CallCompositeContainer = (props: CallCompositeContainerProps): JSX.Element => {
  const { adapter } = props;
  const { currentTheme, currentRtl } = useSwitchableFluentTheme();
  const isMobileSession = useIsMobile();

  useEffect(() => {
    const disposeAdapter = (): void => adapter?.dispose();
    window.addEventListener('beforeunload', disposeAdapter);
    return () => {
      window.removeEventListener('beforeunload', disposeAdapter);
    };
  }, [adapter]);

  if (!adapter) {
    return <Spinner label={'Creating adapter'} ariaLive="assertive" labelPosition="top" />;
  }

  const callInvitationUrl: string | undefined = window.location.href;

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <CallComposite
        adapter={adapter}
        fluentTheme={currentTheme.theme}
        rtl={currentRtl}
        callInvitationUrl={callInvitationUrl}
        formFactor={isMobileSession ? 'mobile' : 'desktop'}
        options={{
          callControls: {
            // Hide ACS end call — doctor uses our custom red button
            endCallButton: false,
            // Hide buttons we don't need in a 1-on-1 medical consultation
            raiseHandButton: false,
            moreButton: false,
            screenShareButton: false,
          },
        }}
      />
    </div>
  );
};
